// ─── PreviewMiniFooter ───────────────────────────────────────────────────────
// The minimal brand-bar footer shown on sealed pages (listing, showcase, venue
// reviews) when the visitor is inside a private-review preview session. Replaces
// the full SiteFooter so a prospect never reaches Browse Venues, The Shop, or the
// Membership/pricing pages from the footer. No outbound links.
// ─────────────────────────────────────────────────────────────────────────────
const NU = 'var(--font-body)';
const GD = 'var(--font-heading-primary)';

export default function PreviewMiniFooter() {
  return (
    <footer style={{ background: '#0a0908', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        gap: 10, padding: '36px 24px 40px',
      }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L22 12L12 22L2 12Z" stroke="#c9a96e" strokeWidth="1.2" fill="none" />
          <path d="M12 6L18 12L12 18L6 12Z" fill="#c9a96e" fillOpacity="0.25" />
        </svg>
        <p style={{ fontFamily: GD, fontSize: 15, fontWeight: 400, letterSpacing: '0.06em',
          color: 'rgba(245,240,232,0.65)', margin: 0, textAlign: 'center' }}>
          Luxury Wedding Directory
        </p>
        <p style={{ fontFamily: NU, fontSize: 10, color: 'rgba(245,240,232,0.3)', margin: 0,
          textAlign: 'center', letterSpacing: '0.04em', lineHeight: 1.6, maxWidth: 260 }}>
          The world's most exceptional venues,<br />curated for discerning couples.
        </p>
        <p style={{ fontFamily: NU, fontSize: 9, letterSpacing: '0.14em', textTransform: 'uppercase',
          color: 'rgba(245,240,232,0.2)', margin: '8px 0 0' }}>
          luxuryweddingdirectory.com
        </p>
        <p style={{ fontFamily: NU, fontSize: 9, color: 'rgba(245,240,232,0.12)', margin: 0,
          letterSpacing: '0.08em', textTransform: 'uppercase' }}>
          Private Preview · Confidential
        </p>
      </div>
    </footer>
  );
}
